import { enableProdMode, StaticProvider } from '@angular/core';
import { APP_CONFIG } from './app-configuration';
import { environment } from '@environment';
import { CONFIG_MAPPING } from '@core/services/config/config.mapping';

let filename;

if (environment.production) {
	enableProdMode();
	filename = CONFIG_MAPPING[location.hostname];
} else {
	//in dev getting the port as well
	filename = CONFIG_MAPPING[location.host];
}

const useVersionsFlagPromise = fetch(
	'https://app.launchdarkly.com/api/v2/flags/default/use-application-version-in-router',
	{
		headers: {
			Authorization: 'api-68a13c21-d929-4585-8107-a9b0e3aefc09',
		},
	},
);
const appsVersionPromise = fetch(`${environment.apiUrl}/bff/apps-version`);
const configPromise = fetch(`/assets/app-config/${filename}`);

export async function setupAppConfig(): Promise<StaticProvider[]> {
	const [flagDataResponse, appsVersionResponse, configResponse] = await Promise.all([
		useVersionsFlagPromise,
		appsVersionPromise,
		configPromise,
	]);
	const [flagData, appsVersion, config] = await Promise.all([
		flagDataResponse.json(),
		appsVersionResponse.json(),
		configResponse.json(),
	]);

	const env = environment.production ? 'production' : 'new-staging';
	if (flagData.environments[env].on) {
		environment.headerUrl = environment.headerUrl.replace(':version', appsVersion.header);
		environment.azureVmUrl = environment.azureVmUrl.replace(':version', appsVersion['azure-vm']);
		environment.commitmentManagerUrl = environment.commitmentManagerUrl.replace(
			':version',
			appsVersion['commitment-manager'],
		);
		environment.sidebarUrl = environment.sidebarUrl.replace(':version', appsVersion.sidebar);
		environment.insightsUrl = environment.insightsUrl.replace(':version', appsVersion.insights);
		environment.kompassUrl = environment.kompassUrl.replace(':version', appsVersion.kompass);
		environment.organizationSettingsUrl = environment.organizationSettingsUrl.replace(
			':version',
			appsVersion['organization-settings'],
		);
		environment.partnerPortalUrl = environment.partnerPortalUrl.replace(':version', appsVersion['partner-portal']);
		environment.ec2ListingsUrl = environment.ec2ListingsUrl.replace(':version', appsVersion['ri-manager']);
		environment.zestyDiskDashboardUrl = environment.zestyDiskDashboardUrl.replace(
			':version',
			appsVersion['zesty-disk-dashboard'],
		);
	} else {
		environment.headerUrl = environment.headerUrl.replace(':version', 'latest');
		environment.azureVmUrl = environment.azureVmUrl.replace(':version', 'latest');
		environment.commitmentManagerUrl = environment.commitmentManagerUrl.replace(':version', 'latest');
		environment.sidebarUrl = environment.sidebarUrl.replace(':version', 'latest');
		environment.insightsUrl = environment.insightsUrl.replace(':version', 'latest');
		environment.kompassUrl = environment.kompassUrl.replace(':version', 'latest');
		environment.organizationSettingsUrl = environment.organizationSettingsUrl.replace(':version', 'latest');
		environment.partnerPortalUrl = environment.partnerPortalUrl.replace(':version', 'latest');
		environment.ec2ListingsUrl = environment.ec2ListingsUrl.replace(':version', 'latest');
		environment.zestyDiskDashboardUrl = environment.zestyDiskDashboardUrl.replace(':version', 'latest');
	}

	return [
		{
			provide: APP_CONFIG,
			useValue: {
				...environment,
				...config,
			},
		},
	];
}
